import { LOGIN, LOGOUT, MARK_AS_LOGIN, UPDATE_PROFILE } from "../actions/types";

let initialState = {
    user: {},
    token: null,
    loggedIn: false,
};

const auth = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN:
            return action.payload;
        case LOGOUT:
            return {
                user: {},
                token: null,
                loggedIn: false,
            };
        case UPDATE_PROFILE:
            return {
                ...state,
                user: action.payload,
            };
        case MARK_AS_LOGIN:
            return {
                ...state,
                loggedIn: true,
            };
        default:
            return state;
    }
};

export default auth;
